import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { useCheckUserRole } from '@/components/HOC/UserRoleGuard';
import { GenericPageHeader } from '@/components/layout/page-header';
import { CompetenceProfilePage } from '@/pages/competence/CompetenceProfilePage';
import { useGlobalStoreSelector } from '@/stores/global.store';
import { ShieldAlert } from 'lucide-react';
import { useLingui, Trans } from '@lingui/react/macro';

function CompetenceMeRoute() {
	const { t } = useLingui();
	const isAdmin = useCheckUserRole('ADMIN');
	const currentUserId = useGlobalStoreSelector((s) => s.user?.id);

	if (!currentUserId) {
		return (
			<div className="flex h-full flex-col">
				<GenericPageHeader title={t`My competence`} />
				<div className="flex flex-1 items-center justify-center">
					<div className="space-y-2 text-center">
						<ShieldAlert className="mx-auto size-10 text-muted-foreground" />
						<p className="text-sm text-muted-foreground">
							<Trans>Access Denied</Trans>
						</p>
					</div>
				</div>
			</div>
		);
	}

	// Members see their own profile read-only and self-report via approval
	// requests. Admins/owners manage their own records directly — no approval.
	return (
		<CompetenceProfilePage
			userId={currentUserId}
			breadcrumbLabel={t`My competence`}
			readOnly={!isAdmin}
			showApprovalRequests={!isAdmin}
		/>
	);
}

export const Route = createFileRoute('/_authenticated/_app/competence/me')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['competence.read'], redirectTo: '/dashboard' }),
	component: CompetenceMeRoute,
});
